<template>
    <div>
        <div class="app-title">
            <em-view-title ref="viewTitle" :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                           :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                           :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"
                                           @showEntityMultipleModalSelect="$_emCommonModalMixin_showMultipleSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="tpmOeeReportTorResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                      :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                      :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                      ref="emTable" :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #left-header>

                                    <em-button
                                        type="gotoChild"
                                        class="btn btn-outline-primary btn-sm"
                                        custom-icon="fa fa-copy"
                                        show-name custom-label="计算OEE"
                                        @click="openDialog">
                                    </em-button>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>

        <el-dialog title="计算OEE" :visible.sync="dialogVisible" :close-on-click-modal='false' append-to-body
                   @close='clearCreateForm'>
            <el-form :model="createForm" ref="createForm" label-width="auto" :inline="true" :rules="rules">
                <el-card>
                    <el-form-item prop="currDate">
                        <span class="demonstration">请选择计算日期：</span>

                        <el-date-picker
                            v-model="createForm.currDate"
                            type="datetime"
                            placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                </el-card>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="calOee()">计算</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
// Author thq
// Date 2023-09-04 10:21:15

import emCommonListMixin from "@/mixin/em/common/list";
import emCustomVuexMixin from "@/mixin/em/customVuex";
import EmCommonApi from "@/mixin/em/common/api";

export default {
    name: "tpmOeeReportTorListView",
    mixins: [emCommonListMixin, emCustomVuexMixin, EmCommonApi],
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    data() {
        return {
            dialogVisible: false,
            createForm: {
                currDate: null
            },
            rules: {
                currDate: [{required: true, message: '请选择计算日期'}]
            },
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        }
    },
    methods: {
        openDialog() {
            this.dialogVisible = true;
        },
        clearCreateForm() {
            this.createForm.currDate = null;
            this.$refs["createForm"].resetFields();
        },
        calOee() {
            const _api = `${this.$_emApiMixin_moduleBaseApi("tpmOeeReportTor")}/tpmOeeReportTor/countOeeData?date=`
                + this.formatDateTime(this.createForm.currDate)
            console.log(_api)

            //注意给后端传递年份查询参数 {s_year: this.year}
            this.$_emApiMixin_get(_api, false).then(value => {
                let data = value;
                console.log(data)

                this.dialogVisible = false;
                this.$refs["emListFilter"].doQuery();
            })


        },
        formatDateTime(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1
            const day = String(date.getDate()).padStart(2, '0');

            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');

            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
    }
};
</script>
